import { createReducer, on } from '@ngrx/store';
import * as PartnerPlantsActions from './partner-plants.actions';
import { partnerPlant } from 'src/app/pages/orders/interfaces/partnerPlants.interface';

export interface PartnerPlantsState {
  response: partnerPlant[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: partnerPlant[] };
}

export const initialState: PartnerPlantsState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const partnerPlantsReducer = createReducer(
  initialState,
  on(PartnerPlantsActions.loadPartnerPlants, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PartnerPlantsActions.loadPartnerPlantsSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(PartnerPlantsActions.loadPartnerPlantsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(PartnerPlantsActions.loadPartnerPlantsSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
  on(PartnerPlantsActions.resetPartnerPlantsState, () => ({ ...initialState })),
);
